'use strict';

var React = require('react');

var SvgReceiptMajor = function SvgReceiptMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.5 0h-11c-.828 0-1.5.677-1.5 1.513v18.207a.2.2 0 0 0 .334.15l1.664-1.515a.497.497 0 0 1 .67 0l1.664 1.514c.19.173.48.173.67 0l1.663-1.514a.497.497 0 0 1 .67 0l1.663 1.514c.19.173.48.173.67 0l1.664-1.514a.497.497 0 0 1 .67 0l1.664 1.515a.2.2 0 0 0 .334-.15v-18.207c0-.836-.672-1.513-1.5-1.513zm-.5 5v-1h-10v2h10v-1zm0 3v2h-10v-2h10zm-4 5v-1h-6v2h6v-1z"
  }));
};

exports.SvgReceiptMajor = SvgReceiptMajor;
